/* src/app/private/components/Batch/delete-batch/delete-batch.component.scss */
/*# sourceMappingURL=delete-batch.component.css.map */
